import { FormationDetailProps } from "@/types/formation";

export const habilitationElectriqueFormation: FormationDetailProps = {
  id: "15",
  title: "Formation Habilitation Électrique",
  description: "Formation permettant au personnel effectuant des opérations d'ordre non électrique simple ou des manœuvres de travailler en sécurité dans des environnements électriques selon les préconisations de la norme NFC 18-510.",
  duration: "14 heures (2 jours)",
  category: "Habilitations",
  imageSrc: "/images/formations/habilitation.webp",
  slug: "habilitation-electrique-bs-be",
  reference: "F-BE/BS",
  price: "Sur devis – nous contacter",
  targetAudience: "Toute personne qui a besoin de réaliser des petits travaux d'ordre électrique (remplacement de prises, de luminaires en basse tension) ou des manœuvres d'exploitation électriques (réarmement disjoncteur, remplacement de fusées, réglage d'équipement électrique....)",
  prerequisites: "Avoir des compétences en électricité dans le domaine de la tension considérée sur les ouvrages ou installations électriques",
  objectives: [
    "Respecter les prescriptions de sécurité liées à la réglementation et aux limites du champ d'intervention des personnes habilitées BS/BE manœuvre",
    "Identifier les types de courant, de contact, leurs effets sur le corps humain et les moyens de protection",
    "Identifier les différents acteurs ainsi que leurs rôles et missions",
    "Mettre en œuvre les procédures de remplacement/raccordement et/ou réaliser l'entretien et les interventions simples d'ordre électrique"
  ],
  program: [
    {
      title: "Partie théorique 40%",
      items: [
        "L'HABILITATION ÉLECTRIQUE",
        "Définition des grandeurs électriques, intensité et accidents correspondants",
        "L'ENVIRONNEMENT ÉLECTRIQUE ET LE TRAVAIL D'ORIGINE ÉLECTRIQUE",
        "Les différents acteurs de l'industrie électrique",
        "Les mesures de prévention en vue de la réalisation d'opérations d'ordre électrique",
        "Les conditions d'intervention et de secours",
        "LES DANGERS DU COURANT ÉLECTRIQUE",
        "Contact direct, contact indirect et le court",
        "Les effets du courant sur le corps humain",
        "Les différents facteurs de gravité d'une électrisation et court-circuit",
        "Les principales sources d'accident d'origine électrique",
        "LES EFFETS DU COURANT SUR LE CORPS HUMAIN",
        "Le direct et l'indirect",
        "La notion d'effet et de contact direct et la tension",
        "La résistance du corps humain",
        "LES PROTECTIONS CONTRE LES CONTACTS DIRECTS ET INDIRECTS",
        "Les zones de circulation, les principes et mise à terre",
        "Les disjoncteurs, les différentiels, prises blindées",
        "L'isolation électrique et la séparation des circuits",
        "La TBTS et la TBTP",
        "LES OPÉRATIONS ÉLÉMENTAIRES",
        "Remplacement d'une lampe, d'un accessoire d'un appareil d'éclairage, d'une prise de courant ou d'un interrupteur à l'identique",
        "Raccordement d'un matériel électrique sur un circuit en attente (domino, plage à bornes)",
        "Le réarmement du dispositif de protection dans le respect des consignes données, le remplacement d'un fusible ou réenclenchement d'un disjoncteur en schéma TT ou TN",
        "La mobilisation de l'appareillage",
        "La modification de l'état électrique d'un réseau ou d'une installation dans le cadre de fonctionnement normal",
        "La mesure de grandeur électrique",
        "Le repérage, le mesurage, l'information et l'avertissement",
        "Le réarmement et la mise de protection",
        "LES APPAREILS DE PROTECTION INDIVIDUELLEMENT ACCESSIBLES",
        "LES ÉQUIPEMENTS DE PROTECTION",
        "Les équipements de protection individuels ou collectifs (gants, casque, tapis isolant…)",
        "La vérification des EPI",
        "LES OUTILS ET LE MATÉRIEL DE TRAVAIL",
        "Le matériel électrique porte-outil (meuleuse, CIL, conforme aux normes, prescription de conception)",
        "L'outillage à main pour électricien, équipement et les machines",
        "LES CONDUITES À TENIR",
        "En cas d'incendie dans un local ou incendie d'origine électrique",
        "En cas d'accident corporel ou d'électrisation",
        "NOTIONS ÉLÉMENTAIRES D'ÉLECTRICITÉ",
        "La production de courant",
        "Les unités et les grandeurs électriques",
        "Les différents types de courant",
        "LES DOMAINES DE TENSION, LES OUVRAGES ET INSTALLATIONS",
        "Les différents domaines de tension",
        "Les limites et les niveaux d'habilitation",
        "LES ZONES D'ENVIRONNEMENT",
        "Le classement des zones d'environnement",
        "Les distances et les zones",
        "LES TITRES D'HABILITATION",
        "Les symboles et les niveaux, les titres d'habilitation",
        "PRÉVENTION DES RISQUES ÉLECTRIQUES",
        "Les protections et les équipements de protection",
        "Les équipements de travail et les outillages électriques (risques de tension, charge d'habilitation électrique)",
        "LES OPÉRATIONS D'ORDRE NON ÉLECTRIQUE",
        "En hors tension",
        "Dans un environnement électrique",
        "Les zones de travail, la surveillance de la zone de travail, le balisage de la zone de travail"
      ]
    },
    {
      title: "Partie pratique 60%",
      items: [
        "EXERCICES INDIVIDUELS DE MISE EN SITUATION",
        "Analyse d'une situation vis-à-vis du risque électrique et définition des mesures de protection adaptées",
        "Évolution dans les zones d'environnement électrique avec application des consignations adaptées",
        "Réalisation d'opérations selon l'habilitation visée",
        "Port des équipements de protection individuelle",
        "TRAVAIL EN SOUS GROUPES",
        "Identification des risques électriques",
        "Identification des risques d'habilitation nécessaire selon différentes situations d'intervention",
        "CAS CONCRET",
        "Réalisation d'opérations d'ordre électrique (exercice pratique sur situation professionnelle) lors des formations",
        "VISITE DES INSTALLATIONS (INTRA-ENTREPRISE)",
        "Présentation des installations et zones concernées par le titre d'habilitation, identification des mesures de prévention applicables"
      ]
    }
  ],
  numberOfParticipants: "10 Participants",
  pedagogicalMethods: [
    "Exposés interactifs, analyses de situations de travail, démonstrations par le formateur, mise en situation pratique"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs conformément aux préconisations de la NFC 18-510",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par évaluation des acquis.",
  registrationProcess: [
    "Inscription par téléphone, par mail ou par le site internet",
    "Délai d'accès selon un agenda interne de session de l'entreprise",
    "Inscription 15 jours avant le début de la formation"
  ],
  maintainingKnowledge: "07h00 tous les 3 ans",
  accessibilityCriteria: "Pour toute personne en situation d'handicap, Nous sommes susceptibles d'accueillir les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
